import config from 'config';
import { http_client } from './api';

const getList = async () => {
  return http_client.get(config.apiUrl + 'role').then((response) => {
    return response.data;
  });
};
const getListArchive = async () => {
  return http_client.get(config.apiUrl + 'role/archive').then((response) => {
    return response.data;
  });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'role', data).then((response) => {
    return response.data;
  });
};

const read = async (id) => {
  return http_client.get(config.apiUrl + 'role/' + id).then((response) => {
    return response.data;
  });
};

const update = async (id, data) => {
  return http_client.patch(config.apiUrl + 'role/' + id, data).then((response) => {
    console.log(response.data);
    return response.data;
  });
};

const del = async (id) => {
  return http_client.delete(config.apiUrl + 'role/' + id).then((response) => {
    return response.data;
  });
};

const getPermissions = async () => {
  return http_client.get(config.apiUrl + 'role/permission').then((response) => {
    return response.data;
  });
};

const updateRolePermission = async (id, data) => {
  return http_client.post(config.apiUrl + 'role/' + id + '/permission', data).then((response) => {
    return response.data;
  });
};
const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'role/status/' + id, data).then((response) => {
    return response.data;
  });
};
const RoleService = {
  getList,
  getListArchive,
  create,
  read,
  update,
  del,
  getPermissions,
  updateRolePermission,
  changeStatus
};

export default RoleService;
